import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import MUICollapse from '@mui/material/Collapse';
import ButtonTitle from './ButtonTitle';
import { collapseClasses as classes } from './collapseClasses';
import { CollapseRoot } from './Collapse.style';

const Collapse = forwardRef(
  (
    {
      title,
      isOpen = false,
      children,
      onClick,
      disabled = false,
      buttonVariant = 'outlined',
      buttonTitlePosition = 'top',
      CollapseProps = {},
      ButtonProps,
      ...rest
    },
    ref
  ) => {
    const ButtonTitleProps = {
      children: title,
      buttonVariant,
      isOpen,
      disabled,
      onClick,
      ...ButtonProps
    };

    return (
      <CollapseRoot
        className={classes.root}
        isOpen={isOpen}
        data-qa-id="collapse--root"
        ref={ref}
        {...rest}>
        {buttonTitlePosition === 'top' && <ButtonTitle {...ButtonTitleProps} />}
        <div
          className={classes.contentWrapper}
          data-qa-id="collapse--content-root">
          <MUICollapse in={isOpen} {...CollapseProps}>
            {children}
          </MUICollapse>
        </div>
        {buttonTitlePosition === 'bottom' && (
          <ButtonTitle {...ButtonTitleProps} />
        )}
      </CollapseRoot>
    );
  }
);

Collapse.propTypes = {
  title: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  buttonVariant: PropTypes.oneOf(['outlined', 'text']),
  buttonTitlePosition: PropTypes.oneOf(['top', 'bottom']),
  /** Supported props to pass to the underline MUI Collapse component */
  CollapseProps: PropTypes.object,
  /**
   * Supported props to pass to the underline MUI Button component.<br/> 
  A required prop in order to support `aria-label` prop provided to the Collapse's `Icon` through `IconProps` */
  ButtonProps: PropTypes.shape({
    IconProps: PropTypes.object.isRequired
  }).isRequired
};

Collapse.classes = classes;
Collapse.displayName = 'Collapse';

export default Collapse;
